import { render, staticRenderFns } from "./customer-office.vue?vue&type=template&id=fdcb0ade&scoped=true&"
import script from "./customer-office.vue?vue&type=script&lang=js&"
export * from "./customer-office.vue?vue&type=script&lang=js&"
import style0 from "./customer-office.vue?vue&type=style&index=0&id=fdcb0ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcb0ade",
  null
  
)

export default component.exports